<template>
  <!-- 移动端预约弹窗 -->
  <div v-if="visible" class="subscribe-modal-overlay" @click="closeModal" @touchmove.prevent>
    <div class="subscribe-modal" @click.stop @touchmove.stop>
      <div class="modal-close" @click="$emit('close')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12 4L4 12M4 4L12 12" stroke="#999" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>

      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-bg-image">
            <img :src="subscribeBg" alt="预约背景" />
          </div>
          <div class="modal-text">
            我们很乐意为您提供以下帮助，以加深您对七鼠智服的了解
          </div>
        </div>

        <div class="feature-list">
          <div class="feature-item">
            <img :src="tickIcon" alt="勾选" class="tick-icon" />
            <div class="feature-content">
              <div class="feature-title">快速上手</div>
              <div class="feature-desc">详尽的产品与功能介绍，帮助您快速上手七鼠智服</div>
            </div>
          </div>
          <div class="feature-item">
            <img :src="tickIcon" alt="勾选" class="tick-icon" />
            <div class="feature-content">
              <div class="feature-title">需求分析</div>
              <div class="feature-desc">专业的产品顾问人员，与您深入沟通使用需求</div>
            </div>
          </div>
          <div class="feature-item">
            <img :src="tickIcon" alt="勾选" class="tick-icon" />
            <div class="feature-content">
              <div class="feature-title">解决方案</div>
              <div class="feature-desc">针对所处行业与业务场景，打造专业的解决方案</div>
            </div>
          </div>
        </div>

        <div class="modal-form">
          <div class="form-title">预约演示</div>
          <form @submit.prevent="submitForm" class="subscribe-form">
            <div class="form-group">
              <label><span class="required">*</span>您的姓名</label>
              <input type="text" v-model="formData.name" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label><span class="required">*</span>您的联系方式</label>
              <input type="tel" v-model="formData.phoneNumber" placeholder="请输入手机号" required />
            </div>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '立即预约' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subscribeBg from '../../../assets/img/com/pc/subscribe_bg.png'
import tickIcon from '../../../assets/img/com/pc/tick_icon.png'
import { subscribeApi } from '@/api/index.js'

export default {
  name: 'SubscribeModalMobile',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subscribeBg,
      tickIcon,
      formData: {
        name: '',
        phoneNumber: ''
      },
      isSubmitting: false
    }
  },
  methods: {
    closeModal(event) {
      if (event.target === event.currentTarget) {
        this.$emit('close')
      }
    },

    submitForm() {
      if (this.formData.phoneNumber.length !== 11) {
        this.$message({
          message: '请输入有效的手机号码',
          type: 'danger',
          duration: 2000,
          customClass: 'high-z-index-message'
        })
        return
      }
      // 防止重复提交
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true

      console.log('提交表单数据:', this.formData)
      subscribeApi(this.formData)
        .then(res => {
          console.log('message', this.$message);
          console.log('API响应:', res)
          if (res.code === 200) {
            this.$message({
              message: '预约成功，我们将尽快与您联系！',
              type: 'success',
              duration: 3000,
              customClass: 'high-z-index-message'
            })
            this.$emit('close')
            this.formData = {
              name: '',
              phoneNumber: ''
            }
          } else {
            this.$message({
              message: res.message || '预约失败，请稍后再试！',
              type: 'error',
              duration: 3000,
              customClass: 'high-z-index-message'
            })
          }
        })
        .catch(error => {
          this.$message({
            message: error.response.data?.message || `请求失败`,
            type: 'error',
            duration: 5000,
            customClass: 'high-z-index-message'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
// 移动端预约弹窗样式
.subscribe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

.subscribe-modal {
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  background: #FFFFFF;
  border-radius: 8px;
  position: relative;
  overflow-y: auto;

  .modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
  }

  .modal-content {
    padding: 20px;

    .modal-header {
      text-align: center;
      margin-bottom: 20px;

      .modal-bg-image {
        width: 100%;
        height: 120px;
        margin-bottom: 16px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .modal-text {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 1.4;
        text-align: left;
      }
    }

    .feature-list {
      margin-bottom: 24px;

      .feature-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;

        .tick-icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          margin-top: 2px;
          flex-shrink: 0;
        }

        .feature-content {
          flex: 1;

          .feature-title {
            font-weight: 600;
            font-size: 14px;
            color: #333333;
            margin-bottom: 4px;
          }

          .feature-desc {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 1.4;
          }
        }
      }
    }

    .modal-form {
      .form-title {
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: center;
        margin-bottom: 20px;
      }

      .subscribe-form {
        .form-group {
          margin-bottom: 16px;

          label {
            display: block;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            margin-bottom: 8px;

            .required {
              color: #FF4D4F;
              margin-right: 4px;
            }
          }

          input {
            width: 100%;
            height: 44px;
            border: 1px solid #D9D9D9;
            border-radius: 4px;
            padding: 0 12px;
            font-size: 14px;
            color: #333333;
            box-sizing: border-box;

            &::placeholder {
              color: #BFBFBF;
            }

            &:focus {
              outline: none;
              border-color: #00A1FF;
            }
          }
        }

        .submit-btn {
          width: 100%;
          height: 44px;
          background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
          border: none;
          border-radius: 4px;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          cursor: pointer;
          transition: opacity 0.3s;
          margin-top: 20px;

          &:hover {
            opacity: 0.9;
          }

          &:active {
            opacity: 0.8;
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;

            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}

// 全局样式，确保消息提示在弹窗之上
:global(.high-z-index-message) {
  z-index: 10000 !important;
}
</style>
